import api from './api'

export const paymentService = {
  getAll: (params?: { search?: string; status?: string; page?: number; limit?: number }) =>
    api.get('/payments', { params }),

  getById: (id: number | string) =>
    api.get(`/payments/${id}`),

  getBySale: (saleId: number | string) =>
    api.get(`/payments/sale/${saleId}`),

  create: (data: any) =>
    api.post('/payments', data),

  update: (id: number | string, data: any) =>
    api.put(`/payments/${id}`, data),

  processRefund: (id: number | string, data: any) =>
    api.post(`/payments/${id}/refund`, data),

  // M-Pesa methods
  initiateMpesaSTK: (data: {
    phone_number: string
    amount: number
    account_reference?: string
    description?: string
    sale_id?: number
    customer_id?: number
  }) => api.post('/payments/mpesa/stk-push', data),

  checkMpesaStatus: (checkoutRequestId: string) =>
    api.get(`/payments/mpesa/status/${checkoutRequestId}`),

  validateMpesaCode: (data: { mpesa_receipt_number: string; expected_amount?: number }) =>
    api.post('/payments/mpesa/validate-code', data),

  completeWithMpesaCode: (data: {
    mpesa_receipt_number: string
    phone_number?: string
    amount: number
    sale_id?: number
    customer_id?: number
    payment_method_id: number
    notes?: string
  }) => api.post('/payments/mpesa/complete', data),

  getMpesaConfig: () =>
    api.get('/payments/mpesa/config'),

  getMethods: () =>
    api.get('/payments/methods'),
}
